import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "px-5",
  style: {"max-height":"900px","overflow-y":"auto"}
}

import { ref, computed, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import SelectEventType from "./SelectEventType.vue";
import EditNormalEvent from "./edit/EditNormalEvent.vue";
import EditPopupEvent from "./edit/EditPopupEvent.vue";
import EditHeaderEvent from "./edit/EditHeaderEvent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEventV2',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const { t } = useI18n();


const modalRef = ref(false);
const eventType = ref<number>(0);
const currentItem = ref<any>(null);
const isChangingType = ref(false);
const normalRef = ref<InstanceType<typeof EditNormalEvent>>();
const popupRef = ref<InstanceType<typeof EditPopupEvent>>();
const headerRef = ref<InstanceType<typeof EditHeaderEvent>>();

const isSubmitting = computed(() => {
  if (isChangingType.value) return true;
  if (eventType.value === 0) return normalRef.value?.isSubmitting ?? false;
  if (eventType.value === 1) return popupRef.value?.isSubmitting ?? false;
  return headerRef.value?.isSubmitting ?? false;
});

const loadActive = async () => {
  const ty = eventType.value;
  if (ty === 0) await normalRef.value?.load(currentItem.value);
  else if (ty === 1) await popupRef.value?.load(currentItem.value);
  else await headerRef.value?.load(currentItem.value);
};

const show = async (item: any) => {
  currentItem.value = item;
  eventType.value = item.type ?? 0;
  modalRef.value = true;
  await nextTick();
  await loadActive();
};

const onTypeChange = async (newType: number) => {
  if (newType === eventType.value) return;
  const oldType = eventType.value;
  isChangingType.value = true;
  try {
    if (oldType === 0) await normalRef.value?.commitType(newType);
    else if (oldType === 1) await popupRef.value?.commitType(newType);
    else await headerRef.value?.commitType(newType);
  } catch (error) {
    MsgPrompt.error(error);
    isChangingType.value = false;
    return;
  }
  currentItem.value = { ...currentItem.value, type: newType };
  eventType.value = newType;
  emits("submit");
  await nextTick();
  await loadActive();
  isChangingType.value = false;
  MsgPrompt.success(t("tip.updateSuccess"));
};

const hide = () => {
  modalRef.value = false;
};

const triggerSubmit = () => {
  if (eventType.value === 0) normalRef.value?.submit();
  else if (eventType.value === 1) popupRef.value?.submit();
  else headerRef.value?.submit();
};

const onChildSubmit = () => {
  emits("submit");
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalRef).value = $event)),
    title: _ctx.$t('action.editEvent'),
    "before-close": hide,
    class: "w-1000px",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: hide,
        disabled: isSubmitting.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: triggerSubmit,
        loading: isSubmitting.value
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          "label-position": "top",
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.eventType'),
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectEventType, {
                  modelValue: eventType.value,
                  "onUpdate:modelValue": onTypeChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        (eventType.value === 0)
          ? (_openBlock(), _createBlock(EditNormalEvent, {
              key: 0,
              ref_key: "normalRef",
              ref: normalRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true),
        (eventType.value === 1)
          ? (_openBlock(), _createBlock(EditPopupEvent, {
              key: 1,
              ref_key: "popupRef",
              ref: popupRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true),
        (eventType.value === 2)
          ? (_openBlock(), _createBlock(EditHeaderEvent, {
              key: 2,
              ref_key: "headerRef",
              ref: headerRef,
              onSubmit: onChildSubmit
            }, null, 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})